import { createReducer, on } from '@ngrx/store';
import { setChartOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
const createUseCustomColorsReducer = (initialState) => createReducer(initialState, on(setChartData, (state, { chartData }) => chartData.params.useCustomColors), on(setChartOption, (state, action) => {
    if (action.chartOption.value === FundChartOptionValue.SHOW_CUSTOM_COLORS) {
        return action.chartOption.selected;
    }
    return state;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.SHOW_CUSTOM_COLORS];
}));
export const useCustomColors = createUseCustomColorsReducer(false);
// The Fund Chart page and the security page Fund Chart tabs start with custom colors on. The store is created from
// each reducer's initial value, and a partial user default or URL state only overwrites the keys it contains.
export const fundChartPageUseCustomColors = createUseCustomColorsReducer(true);
